import * as Yup from "yup";

export default Yup.object().shape({
    code: Yup.string().required("Please enter name"),
    discount: Yup.number().required("Please enter Discount %"),
    isActive: Yup.bool()
});